import React, { useState } from "react";
import marketingImg from "../../assets/marketing.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import { TbSpeakerphone } from "react-icons/tb";
import { FaRobot } from "react-icons/fa";

const styles = `
  .marketing-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .marketing-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .marketing-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .marketing-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .marketing-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .marketing-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .marketing-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .marketing-triangle-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .marketing-triangle-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg, #2fb7a4 30%, #2f6f9f 60%, #2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .marketing-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .marketing-title-group h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .marketing-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    background: #f7f7f7;
    align-items: center;
  }

  .marketing-img-wrapper {
    flex: 1;
  }

  .marketing-img-wrapper img {
    width: 100%;
    max-width: 600px;
    display: block;
  }

  .marketing-accordion {
    flex: 1.2;
  }

  .accordion-item {
    margin-bottom: 18px;
  }

  .accordion-header {
    background: linear-gradient(90deg, #2fb7a4 0%, #2f6f9f 60%, #2f4a7f 100%);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
  }

  .accordion-arrow {
    font-size: 25px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .marketing-header {
      height: auto;
      min-height: 90px;
    }

    .marketing-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .marketing-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .marketing-title-group h2 {
      font-size: 26px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .marketing-header {
      flex-direction: column;
      height: auto;
    }

    .marketing-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .marketing-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .marketing-triangle-left,
    .marketing-triangle-right {
      width: 50px;
    }

    .marketing-title-group h2 {
      font-size: 22px;
    }

    .marketing-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .marketing-img-wrapper {
      width: 100%;
    }

    .marketing-img-wrapper img {
      max-width: 100%;
    }

    .marketing-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .marketing-header {
      flex-direction: column;
      height: auto;
    }

    .marketing-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .marketing-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .marketing-header-badge span:first-of-type {
      font-size: 12px;
    }

    .marketing-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .marketing-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .marketing-triangle-left,
    .marketing-triangle-right {
      width: 36px;
    }

    .marketing-title-group h2 {
      font-size: 18px;
    }

    .marketing-title-group svg {
      font-size: 24px !important;
    }

    .marketing-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .accordion-header {
      font-size: 14px;
      padding: 8px 14px;
    }

    .accordion-arrow {
      font-size: 20px;
    }

    .accordion-body {
      padding: 14px 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .marketing-title-group h2 {
      font-size: 15px;
    }

    .accordion-header {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
`;

function MarketingPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1. Marketing analytics",
      content:
        "These idea tracks media action and offer insights into PR efforts to highlight what is driving engagement, traffic, and revenue."
    },
    {
      title: "2. Personalized Marketing",
      content:
        "AI support businesses in this task and support them in giving personalized experiences for customers."
    },
    {
      title: "3. Context-Aware Marketing",
      content:
        "AI can protect the brand and rise marketing productivity by confirming the content fits its context."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* ===== HEADER ===== */}
      <div className="marketing-header">
        {/* LEFT */}
        <div
          className="marketing-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="marketing-header-overlay" />

          <div className="marketing-header-badge">
            <div className="marketing-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="marketing-header-right">
          {/* LEFT TRIANGLE */}
          <div className="marketing-triangle-left" />

          {/* RIGHT TRIANGLE */}
          <div className="marketing-triangle-right" />

          {/* TITLE */}
          <div className="marketing-title-group">
            <TbSpeakerphone
              style={{
                fontSize: "32px",
                color: "#19bca4",
                strokeWidth: 1
              }}
            />

            <h2>Marketing</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN ===== */}
      <div className="marketing-main">
        <div className="marketing-img-wrapper">
          <img src={marketingImg} alt="" />
        </div>

        <div className="marketing-accordion">
          {data.map((item, i) => (
            <div key={i} className="accordion-item">
              <div
                className="accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default MarketingPage;
